<template slot="header">

  <div class="gg gg-table bc-gray"
       v-bind:class="getSizeClasses()"
       v-b-tooltip.hover
       v-b-tooltip.nofade="getTooltipText"
       v-if="getIsAvailable">

    <div class="ti-headerrow d-flex"
         v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }">
      <div class="over flex-grow-1" style="white-space: unset; overflow: hidden; text-overflow: ellipsis;">
        <p v-bind:class="{ narrow_05: isNarrow, narrow_10: isVeryNarrow, localheading: isHeader }">
          <font-awesome-icon name="fa-thumbs-up" icon="star" v-if="hasStar"></font-awesome-icon>
          <span v-if="!fixContractualStandards">{{ showStandard ? getCustomizedStandardKpiName : ''}}{{ getKpiName }}</span>
          <span v-else>{{ kpi.KpiName }}</span>
        </p>
      </div>
      <button v-if="!disabled" class="kpi-question-button" @click="handleKpiQuestionsClick">
        <font-awesome-icon :icon="['far', 'list']" /> {{ $t('Webportal.DashboardBMW.Q&A') }}
      </button>
    </div>

    <performanceitem  v-if="!disabled"
                      :invertArrow="invertArrow"
                      :isHeader="isHeader"
                      :overallByWave="overallByWave"
                      :kpi="getEffectiveKpi"
                      :isLostLead="isLostLead"
                      :showPrewaves="showPrewaves"
                      :showInlineYtd="showInlineYtd"
                      :monochrome="monochrome"
                      :isBMWMoto="isBMWMoto"
                      :thresholds="thresholds" />
    <div v-else class="disabled">
      <span>{{ disabledText }}</span>
    </div>

    <div v-if="showNpsBar">
      <npsbar :kpi="kpi" />
    </div>
  </div>
  <div  v-else
        class="ti-table bc-gray"
        v-bind:class="getSizeClasses()"
        style="opacity: 0.3; height:58px; margin-bottom: 2px;">
    <div  class="ti-headerrow ti-cell"
          v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }"></div>
  </div>
</template>

<script>
  import EventBus from '@/services/EventBus.js'
  import npsbar from '@/components/Dashboard-bmw/NpsBar';
  import performanceitem from './PerformanceItem2021';
  import ytdMixin from '@/mixins/YearToDateMixin.js';
  import KpiItemMixin from '@/mixins/bmw/KpiItemMixin.js';

  export default {
    components: {
      performanceitem,
      npsbar
    },
    mixins: [ ytdMixin, KpiItemMixin ],
    data() {
      return {
        lockedText: undefined
      }
    },
    props:{
      disabled: { type: Boolean, default: false },
      disabledText: { type: String, default: null },
      fixContractualStandards: { type: Boolean, required: false },
      thresholds: { type: Array, required: true },
      showStandard: { type: Boolean, default: false }
    },

    computed: {
      getCustomizedStandardKpiName: function() {
        return this.kpi.KpiNameShort + ' ';
      }
    },

    methods: {
      handleKpiQuestionsClick(event) {
        EventBus.$emit('Modal-Kpi-Questions', { visible: true, kpi: this.kpi });
      }
    }
  };

</script>

<style scoped>
  .disabled {
    height: 36px;
    width: 100%;
    text-align: center;
    line-height: 2.0rem;
    font-size: 10pt;
  }

  .gg-table {
    font-size: 12pt;
    font-size-adjust: inherit;
    width: 100%;
    /* margin-block-end: 3px; */
    display: block;
  }
  .gg {
    grid-template-rows: 18px auto;
  }


  .ti-row {
    height: auto;

    /* border: indianred solid; */
    float: inherit;
    width: 100%;
    /* margin-left: 5px; */
    display: table-row;
  }

  .ti-cell {
    /* text-align: left; */
    width: 100%;
    text-overflow: ellipsis;
    margin: 0;
    padding: 0;
    padding: 0px;
    display: table-cell;
  }



  .localheading {
     font-size: 12pt;
  }
  .narrow {
    letter-spacing: -0.05em;
    width: 160px;
  }
  .over {
    height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  dic.ti-cell{
    align-content: center;
    align-content: space-around;
  }
  p{
    font-size: 9pt;
    font-weight: bold;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    margin-left: 3px;
  }
  .tiny {
    color: black;
    font-size: 7pt;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    top: -2px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
